"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onRouteUpdate = void 0;
exports.onRouteUpdate = async ({ location }) => {
    if (typeof window === "undefined" || !location) {
        return true;
    }
    try {
        const savedPosition = JSON.parse(sessionStorage.getItem("savedPosition"));
        if (savedPosition.pathname === location.pathname) {
            window.scrollTo({ top: savedPosition.position });
            return true;
        }
    }
    catch (err) { }
    try {
        if (location.hash) {
            const item = document.querySelector(`${location.hash}`)?.offsetTop;
            window.scrollTo({ top: item });
            return true;
        }
    }
    catch (err) { }
    return true;
};
//# sourceMappingURL=onRouteUpdate.js.map